import { render, staticRenderFns } from "./outputManagementWorks.vue?vue&type=template&id=2f8ca15f&scoped=true&"
import script from "./outputManagementWorks.vue?vue&type=script&lang=js&"
export * from "./outputManagementWorks.vue?vue&type=script&lang=js&"
import style0 from "./outputManagementWorks.vue?vue&type=style&index=0&id=2f8ca15f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8ca15f",
  null
  
)

export default component.exports